<!-- @format -->
<!-- Migrated from AngularJS: cancelApplicationModal.tpl.html -->

<div class="modal-header">
  <h2 class="modal-title" tabindex="0">
    <span>{{ "PROFILE.APPLICATIONS.CANCEL_APPLICATION_MODAL.TITLE." + values.application.type | translate }}</span>
  </h2>
</div>
<div class="modal-body">
  <p>{{ "PROFILE.APPLICATIONS.CANCEL_APPLICATION_MODAL.SUBTITLE" | translate }}</p>
  <p class="lowercase-subtitle">
    <span>{{ "PROFILE.APPLICATIONS.CANCEL_APPLICATION_MODAL.CONFIRMATION." + values.application.type | translate }}</span>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-hollow btn-lg" (click)="dismiss()">{{ "CANCEL" | translate }}</button>
  <button type="button" class="btn btn-primary btn-lg" (click)="confirm()">{{ "BUTTON.YES" | translate }}</button>
</div>
